import React, { useEffect, useState } from "react";
import API from '../Services/PlayPoint'
import APIS from '../Services/MemberShip'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";


const RefundList = () => {
    const [paymentAmount, setPaymentAmount] = useState("")
    const [playPoint, setPlayPoint] = useState("")
    const [error, setError] = useState({});
    const perPage = 10
    const [currentPage, setCurrentPage] = useState(1);
    const [refundAmountList, setRefundAmountList] = useState([])
    const [totalRecords, setTotalRecords] = useState(0);
    const [id, setId] = useState([])
    const [status, setStatus] = useState("");
    const [createdAt, setCreatedAt] = useState("");

    useEffect(() => {
        getRefundList()
    }, [currentPage]);



    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...(prevErrors || {}) };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "paymentAmount":
                setPaymentAmount(value);
                break;
            case "playPoint":
                setPlayPoint(value);
                break;
            default:
                break;
        }
    };


    const validateFields = () => {
        const errors = {};
        const priceRegex = /^\d+(\.\d{1,2})?$/;
        if (!paymentAmount || String(paymentAmount).trim() === "") {
            errors.paymentAmount = "Payment amount is required";
        } else if (!priceRegex.test(String(paymentAmount))) {
            errors.paymentAmount = "paymentAmount must be a valid number (e.g., 100 or 100.50)";
        }
        const PlayPoint = /^\d+(\.\d{1,2})?$/;
        if (!playPoint || String(playPoint).trim() === "") {
            errors.playPoint = "SkyCoins is required";
        } else if (!PlayPoint.test(String(playPoint))) {
            errors.playPoint = "SkyCoins must be a valid number (e.g., 100 or 100.50)";
        }

        setError(errors);
        return Object.keys(errors).length === 0;
    };


    const getRefundList = async () => {
        try {
            const payload = {
                limit: perPage,
                pageNumber: currentPage
            };
            const response = await API.getPlayPoint(payload);

            setRefundAmountList(response?.data?.data?.rows)
            //setPlayPointList(response?.data?.data?.rows)
            // setTotalRecords(response?.data?.data?.count)
        } catch (error) {
            toast.dismiss();
            if (!error.response) {
                toast.error("Network error! Please check your internet connection");
            } else if (error.response.status === 403) {
                window.location.replace("/Login")
                toast.error("Network error! Please check your internet connection.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };


    const totalPages = Math.ceil(totalRecords / perPage);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);

        }
    };

    const changeStatus = async (id, currentStatus) => {
        const updatedStatus = !currentStatus;
        try {
            const response = await API.changePlayPointStatus(id, updatedStatus);
            if (response.status === 200) {
                setRefundAmountList((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(
                    `SkyCoins ${updatedStatus ? "Activated" : "De-Activated"} successfully!`
                );
                getRefundList();
            } else {
                console.log("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found (404)');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.log("Error in status toggle:", error);
            toast.error("Failed to update the status. Please try again.");
        }
    };


    const handleGetData = async (pointId) => {
        try {
            const response = await API.getPlayPoint({ id: pointId });
            const fetchedData = response?.data?.data?.rows?.[0];
            if (fetchedData) {

                setId(fetchedData.id);
                setPaymentAmount(fetchedData?.payment_amount)
                setPlayPoint(fetchedData?.play_point)

                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            } else {
                toast.error("Failed to fetch SkyCoins details.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found (404)');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    };

    const updatePlayPointData = async () => {
        if (!validateFields()) return;
        try {
            const payload = {
                payment_amount: paymentAmount,
                play_point: playPoint,
                //membership_id: selectMembership,
            };
            const response = await API.updatePlayPointStatus(id, payload);
            // console.log('f', response.data)
            if (response?.status === 200) {
                toast.success(response?.data?.message);

                getRefundList();
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Failed to update SkyCoins. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found (404)');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error updating designation:", error);
            toast.error("An unexpected error occurred. Please try again later.");
        }
    }
    const handleSubmit = async () => {
        await updatePlayPointData();

    };

    return (
        <div>

            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Added Refund Amount</h4>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>SrNo</th>
                                        <th>Action</th>
                                        <th>Payment Amount</th>
                                        <th>SkyCoins</th>
                                        <th>Created-Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {refundAmountList.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>{(currentPage - 1) * perPage + index + 1}</td>

                                            <td>
                                                <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                    <ul className="navbar-nav navbar-nav-right">
                                                        <li className="nav-item nav-profile1">
                                                            <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <div className="nav-profile-text1">
                                                                    <p className="mb-1 text-black">
                                                                    </p>
                                                                </div>
                                                            </span>
                                                            <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                            <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalViewRefund">
                                                                        View
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)}
                                                                        className="btn btn-primary btn-sm" type="button"
                                                                        data-bs-toggle="modal" data-bs-target="#myModalRefundEdit"
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    <button
                                                                        className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                        onClick={() => changeStatus(item.id, item.is_active)}
                                                                    >
                                                                        {item.is_active ? "De-Activated" : "Activate"}
                                                                    </button>
                                                                </a>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>

                                            </td>
                                            <td>{item.payment_amount}</td>
                                            <td>{item.play_point}</td>
                                         
                                            <td>
                                                {moment(item.createdAt).format("DD-MM-YYYY")}
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination justify-content-center mt-4">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </button>
                                    </li>

                                    {Array.from({ length: totalPages }, (_, index) => (
                                        <li
                                            key={index + 1}
                                            className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(index + 1)}
                                            >
                                                {index + 1}
                                            </button>
                                        </li>
                                    ))}

                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>

                </div>
            </div>

            <section>
                <div className="modal fade" id="myModalRefundEdit" data-bs-backdrop="static">
                    <div className="modal-dialog ">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h4 className="modal-title">Update Refund</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>

                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Refund Amount <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Payment Amount"
                                                value={paymentAmount}
                                                onChange={(e) => handleFieldChange(e, "paymentAmount")}
                                            />
                                            {error?.paymentAmount && (
                                                <span className="text-danger" style={{ fontSize: "12px" }}>
                                                    {error.paymentAmount}
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>SkyCoins <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="SkyCoins"
                                                value={playPoint}
                                                onChange={(e) => handleFieldChange(e, "playPoint")}
                                            />
                                            {error?.playPoint && (
                                                <span className="text-danger" style={{ fontSize: "12px" }}>
                                                    {error.playPoint}
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                </div>
                                <div className="mt-2">
                                    <button className="btn btn-primary me-3" type="button" onClick={handleSubmit}>Update</button>

                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="modal" id="myModalViewRefund">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Refund Details</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">

                                <table class="table table-bordered border-secondary">
                                    <thead>
                                        <tr>
                                            <th>Amount</th>
                                            <th>SkyCoins</th>

                                        </tr>
                                        <tr>

                                            <td>{paymentAmount}</td>

                                            <td>{playPoint}</td>

                                        </tr>
                                        <tr>

                                            <th>Status</th>
                                            <th colSpan={2}>Created Date</th>

                                        </tr>
                                        <tr>

                                            <td>{status ? "Active" : "De-Activated"}</td>
                                            <td colSpan={2}>{moment(createdAt).format("DD-MM-YYYY")}
                                            </td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div className="modal-footer">

                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>

    );
};

export default RefundList;